export const createSetTargetAutomationEvent = (target, startTime, timeConstant) => {
    return { startTime, target, timeConstant, type: 'setTarget' };
};
//# sourceMappingURL=create-set-target-automation-event.js.map